import { render, staticRenderFns } from "./FireworksSmall.vue?vue&type=template&id=3ca0278e&scoped=true"
import script from "./FireworksSmall.vue?vue&type=script&lang=js"
export * from "./FireworksSmall.vue?vue&type=script&lang=js"
import style0 from "./FireworksSmall.vue?vue&type=style&index=0&id=3ca0278e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0278e",
  null
  
)

export default component.exports